// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604091401/js/" + chunkId + "." + {"44":"e741fbef","225":"1170d84e","481":"4e190e72","486":"f8b56c2b","770":"d0a12dfd"}[chunkId] + ".0.8127855973031022.chunk.js";
};